<template lang='pug'>
.goToTop.show--smallScreens(@click='')
  i.icon-up
</template>
<script>

import $ from 'jquery'

export default {
  mounted() {
    $('.goToTop').click(function () {
        $('html, body').animate({
            scrollTop: 0
        }, 600);
        return false;
    });
  }
}
</script>
